import React from 'react';

import { ThemeProvider, styled } from 'styled-components';
import { theme } from '../theme/aikya';
import { useElementVisibility } from '../hooks/useElementVisibility';

import { Header } from './Header';
import { ContactBlock } from './ContactBlock';
import { SupportBlock } from './SupportBlock';
import { BengalHeaderBlock } from './BengalHeaderBlock';
import { BengalTextBlock } from './BengalTextBlock';
import { BengalSpecBlock } from './BengalSpecBlock';
import { BengalOpenSourceBlock } from './BengalOpenSourceBlock';
import { BengalBuildBlock } from './BengalBuildBlock';
import { FooterSection } from './FooterSection';
import { BengalSecondaryHeader } from './BengalSecondaryHeader';

const BengalPageWrapper = styled.div`
    margin-top: 3rem;
    height: calc(100vh - 3rem);
    overflow-y: scroll;
    scroll-snap-type: y proximity;

	@media only screen and (orientation:landscape) {
		scroll-snap-type: none;
	}
`;

export const BengalPage = () => {
	const { elementRef: bengalHeaderRef, isHidden } = useElementVisibility();

	return (
		<ThemeProvider theme={theme}>
			<Header />
			<BengalSecondaryHeader isVisible={isHidden} />
			<BengalPageWrapper>
				<BengalHeaderBlock ref={bengalHeaderRef} />
				<BengalTextBlock />
				<BengalOpenSourceBlock />
				<BengalSpecBlock />
				<BengalBuildBlock />
				<ContactBlock />
				<SupportBlock />
				<FooterSection />
			</BengalPageWrapper>
		</ThemeProvider>
	)
}